export default __webpack_public_path__ + "static/carleaseOverview2-f76b358d13ffd05a1b4d35573c4aff6e.avif";